<template>
	<div class="tool-bar clear">
		<slot></slot>
	</div>
</template>
<script>
	export default {
		name: 'toolBar'
	}
</script>



// WEBPACK FOOTER //
// src/components/toolBar/toolBar.vue